const global = window

inputs.types.file = function (data, name, niceName, type, input, parent, inputWindow) {
    console.log("[File Field] Initializing field:", name, { data, type, input, parent });

    var dropzone = input.closest('.file-dropzone');
    if (!dropzone.length) {
        console.warn("[File Field] Dropzone element not found for field:", name);
        return data;
    }

    var filename = dropzone.find('.file-dropzone__filename');
    var deleteInput = dropzone.find('.file-dropzone__delete-input');
    var removeBtn = dropzone.find('.file-dropzone__remove-btn');

    // --- Sélection par clic ---
    input.on("change", function() {
        var files = this.files;
        console.log("[File Field] Input change triggered. Files selected:", files ? files.length : 0);
        if (files && files.length > 0) {
            if (deleteInput.length) {
                deleteInput.val('0');
                console.log("[File Field] Reset delete status to 0");
            }
            showFile(files[0]);
        }
    });

    // --- Prévenir le comportement par défaut de l'ouverture du fichier sur la fenêtre globale ---
    var preventDefault = function(e) {
        if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.types && Array.from(e.originalEvent.dataTransfer.types).includes('Files')) {
            e.preventDefault();
        }
    };
    $(window).on("dragover drop", preventDefault);

    // --- Drag & drop ---
    dropzone.on("dragenter dragover", function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.addClass("dragover");
    });

    dropzone.on("dragleave", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!dropzone[0].contains(e.originalEvent.relatedTarget)) {
            dropzone.removeClass("dragover");
        }
    });

    dropzone.on("drop", function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.removeClass("dragover");

        var files = e.originalEvent.dataTransfer.files;
        console.log("[File Field] File dropped. Files count:", files ? files.length : 0);
        if (files && files.length > 0) {
            if (deleteInput.length) {
                deleteInput.val('0');
                console.log("[File Field] Reset delete status to 0");
            }
            // Injecter les fichiers droppés dans l'input natif
            try {
                var dt = new DataTransfer();
                for (var i = 0; i < files.length; i++) dt.items.add(files[i]);
                input[0].files = dt.files;
                console.log("[File Field] Injected files into native file input");
            } catch (ex) {
                console.error("[File Field] Failed to inject files using DataTransfer:", ex);
            }
            showFile(files[0]);
        }
    });

    // --- Bouton Supprimer ---
    if (removeBtn.length) {
        removeBtn.on("click", function(e) {
            console.log("[File Field] Remove button clicked");
            e.preventDefault();
            e.stopPropagation();

            // Vider l'input de fichier
            input.val('');

            // Signaler la suppression
            if (deleteInput.length) {
                deleteInput.val('1');
                console.log("[File Field] Set delete status to 1");
            }

            // Mettre à jour la vue
            dropzone.removeClass("has-file");
            if (filename.length) filename.text('');

            var existing = dropzone.find(".file-dropzone__preview, .file-dropzone__current-file");
            if (existing.length) existing.hide();
        });
    }

    function showFile(file) {
        console.log("[File Field] Previewing file:", file.name, "Type:", file.type, "Size:", file.size);
        dropzone.addClass("has-file");

        // Masquer le preview existant
        var existing = dropzone.find(".file-dropzone__preview, .file-dropzone__current-file");
        if (existing.length) existing.hide();

        // Afficher le nom du fichier
        if (filename.length) filename.text(file.name);

        // Preview image si applicable
        var imgTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/svg+xml"];
        if (imgTypes.indexOf(file.type) !== -1) {
            console.log("[File Field] File is image, reading data URL for preview");
            var reader = new FileReader();
            reader.onload = function(ev) {
                var preview = dropzone.find(".file-dropzone__preview");
                if (!preview.length) {
                    preview = $('<div class="file-dropzone__preview"></div>');
                    dropzone.append(preview);
                }
                var img = $('<img class="file-dropzone__preview-img" />');
                img.attr('src', ev.target.result);
                preview.html("").append(img);
                preview.show();
                console.log("[File Field] Image preview updated successfully");
            };
            reader.readAsDataURL(file);
        } else {
            console.log("[File Field] File is not an image. Rendering file text indicator.");
            var docPreview = dropzone.find(".file-dropzone__current-file");
            if (!docPreview.length) {
                docPreview = $('<div class="file-dropzone__current-file"><i class="fa fa-file"></i> <span></span></div>');
                dropzone.append(docPreview);
            }
            docPreview.find('span').text(file.name);
            docPreview.show();
        }
    }

    return data;
}
